define('TescoMobile_Checkout/js/view/about',['jquery', 'Magento_Ui/js/form/form', 'Magento_Checkout/js/model/quote', 'Magento_Checkout/js/model/step-navigator', 'TescoMobile_Checkout/js/model/agreement-validator', 'TescoMobile_Checkout/js/action/set-about-information', 'TescoMobile_Checkout/js/action/upgrade/save-request-sim', 'uiRegistry', 'mage/translate', 'Magento_Checkout/js/model/checkout-data-resolver', 'Magento_Checkout/js/checkout-data', 'Magento_Customer/js/model/customer', 'ko', 'underscore', 'TescoMobile_Checkout/js/action/update-customer-clubcard', 'Magento_Ui/js/modal/modal'], function ($, Component, quote, stepNavigator, agreementValidator, setAboutInformation, saveRequestSim, registry, $t, checkoutDataResolver, checkoutData, customer, ko, _, customerUpdateClubCard, modal) {
  'use strict';

  var _checkoutConfig$tesco, _checkoutConfig$tesco2;
  const checkoutConfig = window.checkoutConfig;
  let popUp = null;
  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/about',
      visible: false,
      requestSimSelector: '#request_sim_upgrade input:radio:checked',
      aboutMainFormSelector: '#co-about-you-form',
      isErrorMessagePopupVisible: false,
      errorMessagePopupTemplate: 'TescoMobile_Checkout/about/error-message-popup',
      errorMessagePopupSelector: '#error-message-popup',
      isCustomerClubCardUpdateEnabled: false
    },
    errorMessage: '',
    additionTextBefore: (checkoutConfig === null || checkoutConfig === void 0 || (_checkoutConfig$tesco = checkoutConfig.tescomobile) === null || _checkoutConfig$tesco === void 0 || (_checkoutConfig$tesco = _checkoutConfig$tesco.careHub) === null || _checkoutConfig$tesco === void 0 || (_checkoutConfig$tesco = _checkoutConfig$tesco.about) === null || _checkoutConfig$tesco === void 0 ? void 0 : _checkoutConfig$tesco.additional_text_before) || '',
    isCustomerLoggedIn: customer.isLoggedIn,
    customerAddress: ko.observable({}),
    isPhoneShop: (checkoutConfig === null || checkoutConfig === void 0 || (_checkoutConfig$tesco2 = checkoutConfig.tescomobile) === null || _checkoutConfig$tesco2 === void 0 || (_checkoutConfig$tesco2 = _checkoutConfig$tesco2.careHub) === null || _checkoutConfig$tesco2 === void 0 || (_checkoutConfig$tesco2 = _checkoutConfig$tesco2.cartConfig) === null || _checkoutConfig$tesco2 === void 0 ? void 0 : _checkoutConfig$tesco2.isPhoneShop) || 0,
    initialize: function () {
      const self = this;
      this._super();
      stepNavigator.registerStep('about', 'about', $t('About you'), this.visible, _.bind(this.navigate, this), this.sortOrder);
      quote.billingAddress(null);
      checkoutDataResolver.resolveBillingAddress();
      checkoutDataResolver.resolveShippingAddress();
      checkoutDataResolver.resolveMarketingPreferences();
      checkoutDataResolver.resolveCustomer();
      if (checkoutConfig.billingAddressFromData) {
        this.customerAddress(checkoutConfig.billingAddressFromData);
        checkoutData.setBillingAddressFromData(checkoutConfig.billingAddressFromData);
      }
      $(document).on('change', '[data-index="tm_account_type"] input[type="radio"]', function () {
        localStorage.setItem('tm_account_type', $(this).val());
      });
      registry.async('checkoutProvider')(function (checkoutProvider) {
        const shippingAddress = checkoutData.getShippingAddressFromData();
        const marketingPreferences = checkoutData.getMarketingPreferences();
        const customer = checkoutData.getCustomer() || {};
        const tmAccountType = localStorage.getItem('tm_account_type');
        if (marketingPreferences && (!self.isCustomerLoggedIn() || self.isUpgradeCart())) {
          checkoutProvider.set('about.marketing_preferences', $.extend(true, {}, checkoutProvider.get('about.marketing_preferences'), marketingPreferences));
        }
        if (quote.getData('customer_tm_clubcard_number')) {
          checkoutProvider.set('about.tm_clubcard_number', quote.getData('customer_tm_clubcard_number'));
        }
        if (self.isCustomerLoggedIn()) {
          return;
        }
        if (tmAccountType && !(customer !== null && customer !== void 0 && customer.tm_account_type)) {
          customer.tm_account_type = tmAccountType;
        }
        if (customer) {
          checkoutProvider.set('about.customer', $.extend(true, {}, checkoutProvider.get('about.customer'), customer));
        }
        if (shippingAddress) {
          if (shippingAddress.firstname) {
            delete shippingAddress.firstname;
          }
          if (shippingAddress.lastname) {
            delete shippingAddress.lastname;
          }
          if (shippingAddress.telephone) {
            delete shippingAddress.telephone;
          }
          checkoutProvider.set('about.billing_address', $.extend(true, {}, checkoutProvider.get('about.billing_address'), shippingAddress));
        }
      });
      this.isErrorMessagePopupVisible.subscribe(function (value) {
        if (value) {
          this.getErrorMessagePopup().openModal();
        }
      }.bind(this));
    },
    isUpgradeCart: function () {
      var _quote$getData;
      return ((_quote$getData = quote.getData('extension_attributes')) === null || _quote$getData === void 0 ? void 0 : _quote$getData.tm_quote_type) === 'UPGRADE';
    },
    initObservable: function () {
      return this._super().observe(['visible', 'isErrorMessagePopupVisible', 'errorMessage']);
    },
    navigate: function (step) {
      step && step.isVisible(true);
    },
    validateCustomFields: function () {
      var forms = $(this.aboutMainFormSelector).find('form');
      var inputs = forms.find('input, select, textarea');
      if (inputs.length) {
        inputs.trigger('focus').trigger('blur');
      }
    },
    setAboutInformation: function () {
      this.source.set('params.invalid', false);
      if (!this.isCustomerLoggedIn()) {
        this.validateCustomFields();
        this.source.trigger('about.customer.data.validate');
        this.source.trigger('about.account.data.validate');
        this.source.trigger('about.billing_address.data.validate');
        this.source.trigger('about.previous_address.data.validate');
        this.source.trigger('about.tm_clubcard_number.data.validate');
      } else {
        this.source.trigger('about.tm_clubcard_number.data.validate');
      }
      if (!agreementValidator.validate() || this.source.get('params.invalid')) {
        this.focusInvalid();
      } else {
        if (this.isUpgradeCart()) {
          var _$;
          saveRequestSim(quote.getQuoteId(), quote.getItems()[0].item_id, !!parseInt((_$ = $(this.requestSimSelector)) === null || _$ === void 0 ? void 0 : _$.val())).done(function () {
            this.submitAboutInformation();
          }.bind(this));
        } else {
          this.submitAboutInformation();
        }
      }
    },
    submitAboutInformation: function () {
      let payload;
      if (this.isCustomerLoggedIn()) {
        payload = {
          marketing_preferences: this.source.get('about.marketing_preferences'),
          tm_clubcard_number: this.source.get('about.tm_clubcard_number')
        };
      } else {
        payload = $.extend(true, {}, this.source.get('about'), {
          customer: {
            email: $('input[name=email]').val()
          },
          account: {
            password: $('#customer-password').val()
          }
        });
      }
      const messageContainer = registry.get('checkout.errors').messageContainer;
      setAboutInformation(messageContainer, payload, this).done(function () {
        var _this$source$get;
        if (payload && payload.hasOwnProperty('customer')) {
          quote.firstName = payload.customer.firstname;
          checkoutData.setCustomer(payload.customer);
        }
        if (payload && payload.hasOwnProperty('billing_address')) {
          checkoutData.setBillingAddressFromData(payload.billing_address);
        }
        if (this.isCustomerClubCardUpdateEnabled && this.isCustomerLoggedIn() && !quote.getData('customer_tm_clubcard_on_file') && ((_this$source$get = this.source.get('about.tm_clubcard_number')) === null || _this$source$get === void 0 ? void 0 : _this$source$get.length) > 0) {
          this.errorMessage(null);
          customerUpdateClubCard(this.source.get('about.tm_clubcard_number')).done(function () {
            stepNavigator.next();
          }).fail(function (response) {
            var _this$getBillingDate;
            const billDate = (_this$getBillingDate = this.getBillingDate()) !== null && _this$getBillingDate !== void 0 ? _this$getBillingDate : $t('next bill date');
            this.isErrorMessagePopupVisible(true);
            this.errorMessage('We’re sorry but we can’t apply your Clubcard number to your ' + 'account right now. Please text CLUBCARD to 28578 free from your Tesco Mobile' + ' before %1 in order to receive the Clubcard points'.replace('%1', billDate));
          }.bind(this));
        } else {
          stepNavigator.next();
        }
      }.bind(this));
    },
    getErrorMessagePopup: function () {
      if (!popUp) {
        const options = {
          type: 'popup',
          responsive: false,
          clickableOverlay: false,
          modalClass: 'error-clubcard-popup',
          buttons: [],
          closed: function () {
            this.isErrorMessagePopupVisible(false);
          }.bind(this)
        };
        popUp = modal(options, $(this.errorMessagePopupSelector));
      }
      return popUp;
    },
    nextStep: function () {
      stepNavigator.next();
      this.isErrorMessagePopupVisible(false);
      this.getErrorMessagePopup().closeModal();
    },
    getBillingDate: function () {
      if (!quote.getData('customer_tm_bill_group')) {
        return null;
      }
      const billingDate = new Date();
      billingDate.setMonth(billingDate.getMonth() + 1);
      billingDate.setDate(quote.getData('customer_tm_bill_group').replace(/\D/g, '') + 1);
      return billingDate.toLocaleDateString('en-GB', {});
    }
  });
});

